import { parseTypeName } from './entity';
import { createDirectedGraph } from 'directed-graph';
import { create } from 'event-emitter';
export const createEntityRegistry = () => {
  const registry = createDirectedGraph();
  const emitter = create();
  const registerEntity = entity => {
    const wasReplaced = registry.node.has(entity.typeName);
    registry.node.set(entity.typeName, entity);
    emitter.emit('registerEntity', {
      entity,
      wasReplaced
    });
  };
  const registerLink = (sourceEntity, targetEntity, link) => {
    const wasReplaced = registry.edge.has(sourceEntity.typeName, targetEntity.typeName);
    registry.edge.add(sourceEntity.typeName, targetEntity.typeName, link);
    emitter.emit('registerLink', {
      sourceEntity,
      targetEntity,
      link,
      wasReplaced
    });
  };
  const getEntityFromTypeName = typeName => {
    const def = registry.node.get(typeName);
    if (!def) {
      throw new Error(`Entity ${typeName} not found in registry`);
    }
    return def;
  };
  return {
    emitter,
    graph: registry,
    getEntityFromTypeName,
    getEntity: instanceKey => getEntityFromTypeName(parseTypeName(instanceKey)),
    registerEntity,
    registerLink
  };
};
export const defaultEntityRegistry = createEntityRegistry();